import React from 'react';
import Input from '../componenti/input/Simple';

const Certificazione = ({
    anteprima, 
    inputValues,
    handleOnChange,
    }) => {
    return (
        <>
            <div style={{padding:'20px'}}>DICHIARA</div>
            che il proprio stato di famiglia è composto 
            <span>
            {anteprima ? <span> dalle seguenti </span> : <><span> da (n°</span><input value={inputValues.nPersone.valore} placeholder={inputValues.nPersone.placeholder} type={inputValues.nPersone.type} onChange={handleOnChange} id={inputValues.nPersone.stile} name="nPersone"/>) </>}
            </span>
            persone:
            {(() => {
                if (inputValues.nPersone.valore === '') {
                    return (
                        <div className='alertText'>inserire il n° di pesone della propria famiglia per continuare la compilazione</div>
                    );
                }
                if (inputValues.nPersone.valore === '1') {
                    return (
                        <div>
                            <Input
                                anteprima={anteprima} 
                                inputValues={inputValues}
                                handleOnChange={handleOnChange}
                                inputName='statoFamiglia1'
                            />
                        </div>
                    );
                }
                if (inputValues.nPersone.valore === '2') {
                    return (
                        <>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia1'
                        /><span>; </span>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia2'
                        />
                        </>
                    );
                }
                if (inputValues.nPersone.valore === '3') {
                    return (
                        <>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia1'
                        /><span>; </span>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia2'
                        /><span>; </span>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia3'
                        /><span>.</span>
                        </>
                    );
                }
                if (inputValues.nPersone.valore === '4') {
                    return (
                        <>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia1'
                        /><span>; </span>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia2'
                        /><span>; </span>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia3'
                        /><span>; </span>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia4'
                        /><span>.</span>
                        </>
                    );
                }
                if (inputValues.nPersone.valore === '5') {
                    return (
                        <>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia1'
                        /><span>; </span>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia2'
                        /><span>; </span>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia3'
                        /><span>; </span>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia4'
                        /><span>; </span>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia5'
                        /><span>.</span>
                        </>
                    );
                }
                if (inputValues.nPersone.valore === '6') {
                    return (
                        <>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia1'
                        /><span>; </span>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia2'
                        /><span>; </span>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia3'
                        /><span>; </span>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia4'
                        /><span>; </span>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia5'
                        /><span>; </span>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia6'
                        /><span>.</span>
                        </>
                    );
                }
                if (inputValues.nPersone.valore === '7') {
                    return (
                        <>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia1'
                        /><span>; </span>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia2'
                        /><span>; </span>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia3'
                        /><span>; </span>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia4'
                        /><span>; </span>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia5'
                        /><span>; </span>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia6'
                        /><span>; </span>
                        <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='statoFamiglia7'
                        /><span>.</span>
                        </>
                    );
                }
            })()}
        </>
        );
    }

export default Certificazione;